import React from 'react';
import PropTypes from 'prop-types';

import { StyledSwitchCheckbox } from './styled';

const SwitchCheckbox = ({
  name,
  checked,
  onChange,
  disabled,
  size = 'big',
  ...rest
}) => {
  return (
    <StyledSwitchCheckbox
      disabled={disabled}
      type='checkbox'
      size={size}
      name={name}
      checked={checked}
      onChange={onChange}
      {...rest}
    />
  );
};

SwitchCheckbox.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SwitchCheckbox;
